/*!
 * Copyright (c) 2017-Present, Okta, Inc. and/or its affiliates. All rights reserved.
 * The Okta software accompanied by this notice is provided pursuant to the Apache License, Version 2.0 (the "License.")
 *
 * You may obtain a copy of the License at http://www.apache.org/licenses/LICENSE-2.0.
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS, WITHOUT
 * WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 *
 * See the License for the specific language governing permissions and limitations under the License.
 */

import { Routes, Route, Navigate, useLocation } from 'react-router-dom';
import { LoginCallback } from '@okta/okta-react';
import { RequiredAuth } from './SecureRoute';

import Loading from '../components/Login_loading';

import Company from '../views/Company';
import Login from '../views/Login';
import Article from '../views/Article';
import Portfolio from '../views/Portfolio';
import PortfolioLists from '../views/PortfolioLists';
import Contact from '../views/Contact';
import About from '../views/About';
import SearchView from '../views/SearchView';
import Settings from '../views/Settings';
import MyTest from '../views/MyTest';
import BulkLoader from '../views/BulkLoader';
import List from '../views/List';
import SubscriptionEditor from '../views/SubscriptionEditor';
import Dashboard from '../views/Dashboard';

// import Download from '../views/Download';
import Theme from '../views/Theme';
import NotFound from '../views/NotFound';
import { useRecoilState } from 'recoil';
import { superuserPermissionAtom } from '../store/config';
import LoginCallbackDowJones from './LoginCallbackDowJones';
import LoginRedirect from '../views/LoginRedirect';

const AppRoutes = () => {
  const [is_superuser] = useRecoilState(superuserPermissionAtom);
  const location = useLocation();

  return (
    <Routes>
      <Route path="/login/callback" element={<LoginCallback loadingElement={<Loading />} />} />
      <Route path="/login/callback/dow-jones" element={<LoginCallbackDowJones loadingElement={<Loading />} />} />
      <Route path="/login-dowjones" element={<Navigate to={`/login${location.search || ''}`} replace />} />
      <Route path="/login" element={<Login />} />
      <Route path="/login-dowjones-redirect" element={<LoginRedirect />} />
      <Route path="/" element={<RequiredAuth />}>
        <Route path="" element={<Portfolio />} />
      </Route>
      <Route path="/company/:companyId" element={<RequiredAuth />}>
        <Route path="" element={<Company />} />
      </Route>
      <Route path="/lists/:listId" element={<RequiredAuth />}>
        <Route path="" element={<List />} />
      </Route>
      <Route path="/lists/" element={<RequiredAuth />}>
        <Route path="" element={<PortfolioLists />} />
      </Route>
      <Route path="/article/:articleId" element={<RequiredAuth />}>
        <Route path="" element={<Article />} />
      </Route>
      <Route path="/theme/:themeId/:companyId" element={<RequiredAuth />}>
        <Route path="" element={<Theme />} />
      </Route>
      <Route path="/contact" element={<RequiredAuth />}>
        <Route path="" element={<Contact />} />
      </Route>
      <Route path="/settings" element={<RequiredAuth />}>
        <Route path="" element={<Settings />} />
      </Route>
      <Route path="/search/:searchTerm" element={<RequiredAuth />}>
        <Route path="" element={<SearchView />} />
      </Route>
      <Route path="/about" element={<RequiredAuth />}>
        <Route path="" element={<About />} />
      </Route>
      <Route path="/myTest" element={<RequiredAuth />}>
        <Route path="" element={<MyTest />} />
      </Route>
      <Route path="/bulkLoader" element={<RequiredAuth />}>
        <Route path="" element={<BulkLoader />} />
      </Route>
      {is_superuser && (
        <Route path="/subscriptionEditor" element={<RequiredAuth />}>
          <Route path="" element={<SubscriptionEditor />} />
        </Route>
      )}
      {/* <Route path="/download" element={<RequiredAuth />}>
        <Route path="" element={<Download />} />
      </Route> */}
      <Route path="/" element={<RequiredAuth />}>
        <Route path="*" element={<NotFound />}></Route>
      </Route>
      {is_superuser && (
        <Route path="/dashboard" element={<RequiredAuth />}>
          <Route path="" element={<Dashboard />} />
        </Route>
      )}
    </Routes>
  );
};

export default AppRoutes;
